import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { manageTranslations as TranslationHelper } from '@morsedigital/i18n_helper';
import { FetchSessions } from '../../actions/sessions';

import SetTimePeriods from './helpers/set_time_period';
import GetColumns, { AdditionalColumns } from './helpers/get_columns';

import Session from './session';
import SessionsHeaders from './sessions_headers';
import PeriodHeader from './presentational/period_header';
import TimePeriod from './time_periods';

const wp = TranslationHelper('javascript')('weekly_programme');

export class SessionsHolderComponent extends Component {
  static propTypes = {
    additional: PropTypes.array.isRequired,
    FetchSessionsData: PropTypes.func.isRequired,
    columns: PropTypes.array.isRequired,
    sessions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { FetchSessionsData } = this.props;
    // console.log(addDays(new Date(), 1));
    FetchSessionsData();
  }

  _renderSessions() {
    const { additional, columns, sessions } = this.props;

    return Object.entries(sessions).map(([key, value]) => (
      <TimePeriod
        Header={period => <PeriodHeader title={wp(`time_periods.${period}`)} />}
        ColumnHeaders={() => <SessionsHeaders columns={columns} />}
        Session={session => (
          <Session additional={additional} session={session} columns={columns} key={`session-${session.id}`} />
        )}
        time={key}
        sessions={value}
        key={`tp-${key}`}
      />
    ));
    // ));
  }

  render() {
    return <section key="sessions">{this._renderSessions()}</section>;
  }
}

const mapStateToProps = ({ columns, general, sessions }) => ({
  additional: AdditionalColumns(columns, general.device),
  columns: GetColumns(columns, general.device),
  sessions: sessions.items ? SetTimePeriods(sessions.items) : [],
});

const mapDispatchToProps = dispatch => ({
  FetchSessionsData: date => dispatch(FetchSessions(date)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SessionsHolderComponent);
